import React from 'react';
import styled from 'styled-components';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import Lightbulb24 from '@honeybook/icons/dist/icons/Lightbulb24';
import { observer } from 'mobx-react';
import { flexColumn } from '@honeybook/hbui/dist/styles/mixins';
import { SideBarSection } from '../StepSideBar/StepSideBar.styles';
import { formatDate } from '../../../../../utils/date.utils';
import useAnalytics from '../../../../../common/useAnalytics';
import { AnalyticsEvents } from '../../../../../services/analytics/analytics-events';
import { useRootStore } from '~/stores/useRootStore';
import colors from '@honeybook/hbui/dist/styles/colors';

const StaticProTip = () => {
    const {
        automationUiStore: {
            isEdit,
            selectedAutomation,
            selectedStep: {
                isDone,
                prevStep,
                isExecutable,
                isTriggerDependencyDone,
                isAfterAutomationApplied
            }
        }
    } = useRootStore();

    const STEP_WILL_TRIGGER_ON_PUBLISH = `Since the ${
        isAfterAutomationApplied
            ? 'automation was already applied'
            : 'previous step has already occured'
    } and the selected delay time is in the past, this step will run once you publish the changes.`;

    const ACTIVATION_DATE = isAfterAutomationApplied
        ? `Reminder: automation was applied on ${formatDate(
              selectedAutomation.applied_date,
              'MMM Dd'
          )}`
        : `Reminder: previous step has occured on ${formatDate(
              prevStep?.doneAt,
              'MMM Dd'
          )}`;

    const IMMEDIATE_STEP =
        'Want to trigger an action immediately after something else occurs? Set its timing to 0 minutes, days, etc. Learn more about triggers here.';

    const tipText = (() => {
        if (isEdit && !isDone && isTriggerDependencyDone) {
            if (isExecutable) {
                return STEP_WILL_TRIGGER_ON_PUBLISH;
            }
            return ACTIVATION_DATE;
        }
        return IMMEDIATE_STEP;
    })();

    const { track } = useAnalytics();

    const onHelpCenterClick = () => {
        track(AnalyticsEvents.AutomationTriggerHelpCenterLink, {
            action: 'click'
        });
    };

    return (
        <ProTipContainer>
            <Lightbulb24 color={colors.neutral900} />
            <HBText type="Body6DarkPrimary">
                {tipText}{' '}
                <a
                    onClick={onHelpCenterClick}
                    target="_blank"
                    rel="noreferrer noopener"
                    href="https://help.honeybook.com/en/articles/4239073-understanding-automation-actions-triggers"
                >
                    Learn more
                </a>
            </HBText>
        </ProTipContainer>
    );
};

const ProTipContainer = styled(SideBarSection)`
    padding: 20px;
    ${flexColumn}
`;

export default observer(StaticProTip);
